
export const EventoInicialState = {
    evento: {
        id_Evento: "",
        id_EventoRef: "",
        placa: "",
        nomeCliente: "",
        tipo: "",
        tipoEvento: "",
        dataEvento: "",
        ocorrenciaBO: "",
        descricao: "",
        descricaoOriginal: "",
        userCadastro: "",
        
        tipoData: "",

        narracao:"",

        codEvento: "",
        codEvenBD: "",

        id_Condutor: "",
        nomeCondutor: "",
        telefoneCondutor: "",
        cpfCondutor: "",

        origem: "",
        destino: "",
        orcamento: 0,

        numeroParcelas: "",
        valorParcela: "",
        diaVencimento: "",
        primeiraParcela: "",

        inicioCReserva: "",
        fimCReserva: "",

        id_UserCadastro: "",

        id_Fornecedor: "",
        fornecedor: "",
        cnpjForne: "",
        chavePix: "",

        dataPart: 0,
        valorPart: "",
        detalhePart: "",

        dataPag: "",
        valorPag: "",
        formaPag: "",

        status: "",
        anexoBO: "",
        anexoCNH: "",

        latitude: "",
        longitude: "",

        plataforma:"",
        
        arquivos: [],
    },
    guincho: {
        origem: "",
        destino: "",
        km: "",
    },
    terceiro: {
        tipo: "",
        placa: "",
        chassi: "",
        anoMod: "",
        montadora: "",
        modelo: "",
        cor: "",
        valorFipe: "",
        anexoCNH: "",
        dataParticipacao: ""
    },

    pagamento: {
        data: "",
        tipo: "",
        novoTipo: "",
        nomeItem: "",
        novoItem: "",
        valorItem: "",
        selectItem: "",
        codigoAtualiza: "",

    },

    orcamento: {
        data: "",
        tipo: "",
        novoTipo: "",
        nomeItem: "",
        novoItem: "",
        valorItem: "",
        selectItem: "",
        codigoAtualiza: "",

    },
}
//-----------------------------------------------------
export const EventoReducer = (state = EventoInicialState, action) => {

    switch (action.type) {

        case 'set_Evento':
            return { ...state, evento: action.payload };
            
        case 'set_Guincho':
            return { ...state, guincho: action.payload };

        case 'set_Terceiro':
            return { ...state, terceiro: action.payload };

        case 'set_Pagamento':
            return { ...state, pagamento: action.payload };

        case 'set_Orcamento':
            return { ...state, orcamento: action.payload };

        case 'set_limparEvento':
            return EventoInicialState;

        default:
            return state;

    }
};
//-----------------------------------------------------
